var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-body album-description"},_vm._l((_vm.description.split('\n')),function(line){return _c('p',{key:line.id,staticClass:"pl-3 py-0 my-0"},[_vm._v(" "+_vm._s(line)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }